/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';

import '~styles/modules/headlineimage.scss';

const HeadlineImage = ({ children }) => (
	<div id="header-title" className="content">
		<h1>Back to Boston</h1>
	  <img src="https://bostonglobe-prod.cdn.arcpublishing.com/resizer/B9N5gnMhKWe2txhObEpuDusBYjY=/arc-anglerfish-arc2-prod-bostonglobe/public/H7TEQ7XXEZBFREVXRXPVET7ZNE.png" />
	</div>
);


export default HeadlineImage;
